import React from "react"
import containerMainStyles from "./containermain.module.css"

const ContainerMain = props => (
    <div className={containerMainStyles.containermain}>{props.children}</div>
)

export default ContainerMain